"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _oss = _interopRequireDefault(require("./components/oss.vue"));
var _pushAdmin = _interopRequireDefault(require("./components/pushAdmin.vue"));
var _Alliance = _interopRequireDefault(require("./components/Alliance.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ThreePartyConfiguration',
  components: {
    oss: _oss.default,
    Alliance: _Alliance.default,
    pushAdmin: _pushAdmin.default
  },
  data: function data() {
    return {
      activeName: 'oss'
    };
  }
};